





















































// @ts-nocheck
import { Component, Vue } from 'vue-property-decorator'
import AsyncComputed from 'vue-async-computed-decorator'
import { DataStore } from 'aws-amplify'
import AddDialog from '@/components/dialogs/Add.vue'
import ConfirmDialog from '@/components/dialogs/Confirm.vue'
import { ITenant } from '@/graphql/tenant/interfaces/tenants'
import { GenerateLocaleDict } from '../lib/Locale'
import { mutateTenant } from '@/store/tenant'
import { mutateSnackbar } from '@/store/snackbar'
import { Tenant, District, Checklist, ChecklistItem, Info, Page, Media, ChecklistMedia } from '../models/index'
import { duplicateDistrict } from "@/views/Districts"
@Component<AdminView>({
  components: {
    AddDialog,
    ConfirmDialog
  },
  // @ts-ignore
  metaInfo() {
    return {
      title: this.$t('admin.title')
    }
  }
})
export default class AdminView extends Vue {
  tenants = []
  tenantsSubscription = null
  isLoading = true
  isDisplayingCloneDialog = false
  isCloning = false
  toClone = {
    tenantId: null,
    targetTenantId: null,
    pages: true,
    districts: true,
    districtSelections: [],
    // media: true,
  }

  created() {
    this.tenantsSubscription = DataStore.observeQuery(Tenant).subscribe(
      ({ items }) => {
        this.tenants = items
        setTimeout(() => {
          this.isLoading = false
        }, 250)
      }
    )
  }
  destroyed() {
    this.tenantsSubscription.unsubscribe()
  }

  @AsyncComputed()
  async availableDistrictsForCloning() {
    const fromTenant = this.toClone.tenantId
    if(!fromTenant) return []
    return (await DataStore.query(District, p => p.tenant.eq(fromTenant))).map(e => ({ text: e.name.de, value: e.id, }))
  }

  async cloneData() {
    this.isCloning = true
    const toClone = this.toClone
    const targetTenantId = this.toClone.targetTenantId;
    if (!targetTenantId) throw Error("Missing target tenant")

    if(this.toClone.districts) {
      for (const districtId of toClone.districtSelections) {
        await duplicateDistrict(await DataStore.query(District, districtId), targetTenantId)
      }
    }

    if(this.toClone.pages) {
      await Promise.all((await DataStore.query(Page, p => p.tenant.eq(this.toClone.tenantId))).map(async e => {
        const { createdAt, updatedAt, ...clone } = e
          await DataStore.save(
            new Page({
              ...clone,
              tenant: targetTenantId || clone.tenant,
              title: {
                de: `${clone.title.de} (Duplikat)`,
              },
            }),
          );
      }))
    }

    setTimeout(() => {
      this.isCloning = false
      this.isDisplayingCloneDialog = false
    }, 250)
  }

  get cloneTargets() {
    return this.tenants
      .map(e => ({ text: e.name.de, value: e.id, }))
      .filter(e => e.value !== this.toClone.tenantId)
  }
  async selectTenant({ id, name }) {
    await mutateTenant(
      {
        tenant: {
          id,
          name,
          __typename: 'Tenant'
        }
      },
      this.$apollo
    )
    mutateSnackbar(
      {
        text: String(`Zu Mandant ${name.de} gewechselt`),
        color: `success`
      },
      this.$apollo
    )
    this.$router.push({ name: 'districts' })
  }

  async addTenant(name: string) {
    try {
      await DataStore.save(
        new Tenant({
          id: `tenant-${name}`,
          name: GenerateLocaleDict({ de: name })
        })
      )
      mutateSnackbar(
        { text: String(`${name} erfolgreich erstelt`), color: `success` },
        this.$apollo
      )
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
  }

  async editTenant(name: string, tenant: ITenant) {
    try {
      await DataStore.save(
        Tenant.copyOf(tenant, updated => {
          updated.name = GenerateLocaleDict({ de: name })
        })
      )
      mutateSnackbar(
        { text: String(`${name} erfolgreich gespeichert`), color: `success` },
        this.$apollo
      )
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
  }

  async deleteTenant(tenant: ITenant) {
    try {
      await DataStore.delete(Tenant, item => item.id.eq(tenant.id))
    } catch (err) {
      mutateSnackbar({ text: err, color: `error`, timeout: 5000 }, this.$apollo)
    }
  }
}
